// Loads Razorpay Checkout.js on demand (avoids blocking initial page load)
let _promise = null;

export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (_promise) return _promise;
  _promise = new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => { _promise = null; resolve(false); };
    document.body.appendChild(script);
  });
  return _promise;
}

export async function openCheckout({ order, user, plan = "yearly", onSuccess, onDismiss }) {
  const ok = await loadRazorpay();
  if (!ok || !window.Razorpay) throw new Error("Payment gateway failed to load. Please check your internet and retry.");
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      order_id: order.order_id,
      name: "PM Poshan Calculator",
      description: plan === "yearly" ? "Yearly Premium — Launch Offer" : "Premium subscription",
      image: "/apple-touch-icon.png",
      theme: { color: "#047857" },
      prefill: {
        name: order.user?.full_name || user?.full_name || "",
        email: order.user?.email || user?.email || "",
        contact: order.user?.mobile || user?.mobile || "",
      },
      notes: { plan },
      handler: (response) => {
        try { onSuccess && onSuccess(response); } catch { /* ignore */ }
        resolve(response);
      },
      modal: {
        ondismiss: () => { onDismiss && onDismiss(); reject(new Error("Payment cancelled")); },
      },
    });
    rzp.on("payment.failed", (resp) => {
      reject(new Error(resp?.error?.description || "Payment failed"));
    });
    rzp.open();
  });
}
